module.exports = __webpack_public_path__ + "static/media/banner-no-book-orders.5079f752.png";